import { render, staticRenderFns } from "./UnsubscriberForm.vue?vue&type=template&id=516b3707"
import script from "./UnsubscriberForm.vue?vue&type=script&lang=js"
export * from "./UnsubscriberForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports